'use client';

import {motion} from 'framer-motion';
import useTopStyle from '../../utils/useTopStyle';
import heroVariants from '../../animation/heroVariants';
import Form from '../Form/Form';

const ContactsHero = () => {
  const ref = useTopStyle(72);

  return (
    <motion.section
      className='form-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='content'>
          <h2 className='title'>
            Try Cylerian for free for
            <span className='highlight'> 15 days</span>
          </h2>
          <p className='text'>Total protection has never been easier. Take advantage of our free 15-day trial and explore the most popular solutions for your business.</p>
          <p className='contact'>
            Call us:{' '}
            <span className='highlight'>
              <a href='tel:+1-833-295-7426'>+1-833-295-7426</a>
            </span>
          </p>
          <p className='contact'>
            Email us:{' '}
            <span className='highlight'>
              <a target='_top' href='mailto:info@cylerian.com'>
                info@cylerian.com
              </a>
            </span>
          </p>
        </div>
        <Form />
      </div>
    </motion.section>
  );
};

export default ContactsHero;

